import { useEffect, useRef, useState } from "react";
import { call, register } from "../../funcStore";
import { logAction } from "../../api/logApi";
import { getActiveFilters } from "../../utils/searchFilters";
import { FILTER_GROUPS } from "../../data/filterGroups";

const styles = {
  activeFilters: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "16px",
  },
  activeFilterChip: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "#f3f2f9",
    color: "#4b3f8f",
    borderRadius: "12px",
    padding: "4px 8px 4px 12px",
    fontSize: "0.85rem",
  },
  activeFilterRemove: {
    border: "none",
    background: "none",
    color: "inherit",
    font: "inherit",
    fontWeight: "bold",
    cursor: "pointer",
    padding: 0,
    lineHeight: 1,
  },
};

function ActiveFilterChips() {
  const COMPONENT_KEY = "activeFilterChips"

  //state
  const STATE_BEFORE_INIT = "beforeInit"
  const STATE_GETTING_FILTER = "gettingFilter"
  const STATE_NO_FILTER = "noFilter"
  const STATE_SHOW_FILTER = "showFilter"
  const STATE_REFLESH = "reflesh"

  const [state,setState] = useState(STATE_BEFORE_INIT)

  //data
  const dataRef = useRef({
    clearTargetTag:"",
    filters:""
  })

  // effect
  useEffect(()=>{
    if(state === STATE_BEFORE_INIT){
      register(`${COMPONENT_KEY}.getClearTarget`,()=>dataRef.current.clearTargetTag)
      register(`${COMPONENT_KEY}.reflesh`,()=>setState(STATE_REFLESH))
      setState(STATE_GETTING_FILTER)
    }
    if(state === STATE_REFLESH){
      setState(STATE_GETTING_FILTER)
    }
    if(state === STATE_GETTING_FILTER){
      const rawFilter = call("searchPage.getAllFilter")
      dataRef.current.filters = getActiveFilters(rawFilter,FILTER_GROUPS)
      setState(dataRef.current.filters.length > 0 ? STATE_SHOW_FILTER:STATE_NO_FILTER
      )
    }
  },[state])



  // render
  if (state !== STATE_SHOW_FILTER) {
    return null;
  }

  return (
    <div style={styles.activeFilters}>
      {dataRef.current.filters.map((item) => (
        <span key={item.key} style={styles.activeFilterChip}>
          {item.label}: {item.value}
          <button
            type="button"
            style={styles.activeFilterRemove}
            onClick={() => {
              logAction("filter_clear", { key: item.key, label: item.label, value: item.value });
              dataRef.current.clearTargetTag = item.key;
              call("searchPage.clearFilter")
            }}
            aria-label={`${item.label}の条件を解除`}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}

export default ActiveFilterChips;
